export default "__VITE_ASSET__68f74777__"